<template>
    <p class="sr-only" role="status" data-testid="status-announcer">{{ announcer.announcement }}</p>
</template>

<script setup lang="ts">
/**
 * The app-level polite live region (`useAnnouncerStore`), for a status message whose own element arrives with it. Mounted
 * once, in app.vue, outside everything that shows or hides the page, so it is in the accessibility tree before anything
 * can fail.
 */
import { useAnnouncerStore } from '~/stores/layout/announcer';

const announcer = useAnnouncerStore();
</script>
